import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export default function HomePage() {
  const navigate = useNavigate()
  const { organisation, loading } = useAuth()

  useEffect(() => {
    if (!loading) {
      if (organisation) {
        navigate('/dashboard')
      } else {
        navigate('/login')
      }
    }
  }, [organisation, loading, navigate])

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  )
}
